import { motion, AnimatePresence } from 'framer-motion';
import { dialogVariants } from './settings.animations';
import styles from '../Settings.module.css';

export interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.dialogOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onCancel}
        >
          <motion.div
            className={styles.dialog}
            variants={dialogVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
            role="alertdialog"
            aria-labelledby="dialog-title"
            aria-describedby="dialog-desc"
          >
            <div className={styles.dialogHeader}>
              <h3 id="dialog-title" className={styles.dialogTitle}>
                {title}
              </h3>
            </div>
            <div className={styles.dialogBody}>
              <p id="dialog-desc" className={styles.dialogText}>
                {message}
              </p>
            </div>
            <div className={styles.dialogFooter}>
              <motion.button
                type="button"
                className={`${styles.dialogBtn} ${styles.dialogBtnCancel}`}
                onClick={onCancel}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Cancel
              </motion.button>
              <motion.button
                type="button"
                className={`${styles.dialogBtn} ${styles.dialogBtnConfirm}`}
                onClick={onConfirm}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {confirmLabel}
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
